import React from 'react';
import Div from '@/shared/Div';
import useScreen from '@/hooks/useScreen';
import { parseMediaFromCMS } from '@/utils/image';
import { memo } from 'react';
import Paragraph from '@/shared/Paragraph';
import Heading from '@/shared/Heading';
import withContentFlags from '@/hoc/withContentFlags';
interface specialEventBannerProps {
  mainLabel: any;
  subLabel: any;
  mobileImage: any;
  desktopImage: any;
}

function SpecialEventBanner(props: specialEventBannerProps) {
  const { isDesktop } = useScreen();
  const { mainLabel, subLabel, mobileImage, desktopImage } = props;

  return (
    <Div
      data-testid="specialBanner"
      className="flex items-center justify-center w-full h-[224px] lg:h-[248px] bg-cover bg-top bg-no-repeat"
      style={{
        backgroundImage: `url(${parseMediaFromCMS(!isDesktop ? mobileImage : desktopImage).src})`,
      }}
    >
      <Div className="text-center flex flex-col gap-s5 w-[300px]">
        <Heading className="text-h-1 md:text-hd-1">{mainLabel}</Heading>
        <Paragraph className="px-s4 md:px-5 text-body-xl md:text-body-2xl">{subLabel}</Paragraph>
      </Div>
    </Div>
  );
}
export default withContentFlags(memo(SpecialEventBanner));
